import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { COLOR_BORDER } from '@assets/color';

const Line = styled.hr`
  border: none;
  background-color: ${COLOR_BORDER};
  margin: ${({ dividerType, marginSize }) =>
    dividerType === 'vertical' ? `0 ${marginSize}px` : `${marginSize}px 0`};

  &.horizontal {
    display: block;
    width: 100%;
    height: 1px;
  }

  &.vertical {
    position: relative;
    top: -1;
    display: inline-block;
    width: 1px;
    height: 13px;
    vertical-align: middle;
  }
`;

const Divider = ({
  style,
  className,
  dividerType = 'horizontal',
  marginSize = 10,
}) => {
  return (
    <Line
      style={style}
      className={`${className} ${dividerType}`}
      dividerType={dividerType}
      marginSize={marginSize}
    />
  );
};

Divider.propTypes = {
  style: PropTypes.objectOf(PropTypes.string),
  className: PropTypes.string,
  dividerType: PropTypes.string,
  marginSize: PropTypes.number,
};

export default Divider;
